import React, { useEffect, useState } from "react";
import {
  Box,
  styled,
  Dialog,
  DialogTitle,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./newScheduleInterview.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {  toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { NewScheduleInterviewAction } from "./../../../Redux/action/NewScheduleInterviewAction";
import { FaRegCalendarCheck } from "react-icons/fa";
import TimezoneSelect from "react-timezone-select";
import { ApplyJobListAction } from "../../../Redux/action/ApplyJobListAction";
import { TeamTableAction } from "../../../Redux/action/TeamTableAction";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2, textAlign: "center" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const NewScheduleInterview = (props) => {
  let department = props?.department;

  const handleTimeInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const [startDate, setStartDate] = useState(new Date());
  const [startDateForPicker, setStartDateForPicker] = useState();
  const [selectedTimezone, setSelectedTimezone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);

  const [state, setState] = useState({
    jobPosition: "",
    interviewMode: "",
    interviewStartTime: "",
    duration: "",
    inteviewType: "",
    round: "1",
  });
  console.log("ssss", state);

  console.log(
    "------------------",
    Number(state.interviewStartTime.split(":")[0])
  );
  console.log(
    "------------------",
    Number(state.interviewStartTime.split(":")[1])
  );

  const { item } = props;

  const defaultEndDate = new Date();
  defaultEndDate.setDate(defaultEndDate.getDate() + 7);
  const today = new Date();

  const selectDateHandler = (d) => {
    setStartDateForPicker(d);
  };

  console.log("DATE-- ", startDate);
  console.log(typeof startDate);

  // const day = startDate.getDate();

  const candidateId = props.CID;
  const jobId = props.jobId;
  const { userResult } = useSelector((state) => state.Auth);
  const vendorId = userResult?.vendorid;

  useEffect(() => {
    if (state.inteviewType === "TECHNICAL") {
      dispatch(TeamTableAction(vendorId, department, candidateId));
    } else if (state.inteviewType === "HR") {
      dispatch(
        TeamTableAction(vendorId, (department = "Human Resources"), candidateId)
      );
    }
  }, [state.inteviewType]);

  const TeamList = useSelector((state) => state.TeamTable.result);

  const {
    interviewMode,
    jobPosition,
    inteviewType,
    round,
    interviewerId,
    interviewStartTime,
    duration,
  } = state;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let dispatch = useDispatch();

  const checkFields = () => {
    const {
      jobPosition,
      interviewMode,
      interviewStartTime,
      duration,
      inteviewType,
      interviewerId,
    } = state;
    // Check if any of the required fields are empty
    if (
      !interviewMode ||
      !interviewStartTime ||
      !duration ||
      !inteviewType ||
      !interviewerId
    ) {
      setIsDisabled(true); // Disable the button if any required field is empty
    } else {
      setIsDisabled(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const day = startDateForPicker.getDate();
    const month = startDateForPicker.getMonth() + 1;
    const year = startDateForPicker.getFullYear();
    const interviewDate = year + "-" + month + "-" + day;
    const content = {
      vendorId,
      interviewMode,
      candidateId,
      jobId,
      inteviewType,
      round,
      interviewerId,
      interviewDate,
      interviewStartTime,
      duration,
      timeZone: selectedTimezone.label,
    };
    const todayDateValue = new Date(today);
    const formDateValue = new Date(startDateForPicker);
    let thirtyMinutesInMillis = 30 * 60 * 1000;

    const addHours = Number(state.interviewStartTime.split(":")[0]);
    const addMinutes = Number(state.interviewStartTime.split(":")[1]);

    formDateValue.setHours(formDateValue.getHours() + addHours);
    formDateValue.setMinutes(formDateValue.getMinutes() + addMinutes);

    if (
      interviewerId == "" ||
      inteviewType == "" ||
      interviewMode == "" ||
      duration == "" ||
      interviewStartTime == ""
    ) {
      setError("Required all fields.");
    } else {
      if (formDateValue - todayDateValue >= thirtyMinutesInMillis) {
        dispatch(NewScheduleInterviewAction(content))
          .then((res) => {
            if (res?.data) {
              handleClose();
              setTimeout(() => {
                dispatch(ApplyJobListAction(props.jobId));
              }, 1000);
            }
          })
          .catch((error) => {
            toast.error(error?.response?.data?.status?.message);
          });
        setError("");
      } else {
        toast.error("interview can be scheduled after 45 minutes ")
      }
    }
  };
  useEffect(() => {
    setError("");
  }, [
    interviewerId,
    inteviewType,
    interviewMode,
    duration,
    interviewStartTime,
  ]);
  const loading = useSelector(
    (state) => state.NewScheduleInterviewData.loading
  );

  useEffect(() => {
    checkFields();
  }, [state]);

  return (
    <>
      {/* <ToastContainer /> */}
      <BootstrapDialog
        style={{ color: "red" }}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Schedule Interview
        </BootstrapDialogTitle>

        {/* =============================== */}
        <form className="interview_form " onSubmit={handleSubmit}>
          <Box className="MuiBox-root">
            <div className="label_job_schedule">
              <label className="small mb-1" htmlFor="inputInterest">
                Interview Type
              </label>
              <select
                style={{ height: "45px" }}
                required
                className="form-select"
                name="inteviewType"
                value={inteviewType}
                onChange={(e) => {
                  handleInputChange(e);
                  setState((prev) => ({
                    ...prev,
                    interviewerId: "",
                  }));
                }}
              >
                <option className="dropdown_option" value="" disabled selected>
                  Select Interview Type
                </option>
                <option className="dropdown_option" value="TECHNICAL">
                  TECHNICAL
                </option>
                <option className="dropdown_option" value="HR">
                  HR
                </option>
              </select>
            </div>

            <div className="label_job_schedule">
              <label className="small mb-1" htmlFor="inputInterest">
                Interviewer
              </label>
              <select
                style={{ height: "45px" }}
                required
                className="form-select"
                name="interviewerId"
                value={interviewerId}
                onChange={handleInputChange}
                disabled={!inteviewType}
              >
                <option className="dropdown_option" value="" disabled selected>
                  Interviewer
                </option>
                {TeamList && TeamList.length > 0 ? (
                  TeamList.map((x, i) => {
                    // Parse numbers from experience strings
                    const years = parseInt(x?.keyExperience) || 0;
                    const months = parseInt(x?.keyExperienceInMonth) || 0;
                    const shouldShowExperience =
                      x?.department !== "Human Resources" &&
                      (years > 0 || months > 0);

                    return (
                      <option
                        key={i}
                        style={{ padding: "5px" }}
                        value={x?.candidateId}
                      >
                        {x?.firstName} &nbsp; - &nbsp; {x?.currentDesignation}
                        {shouldShowExperience && (
                          <>
                            &nbsp; - &nbsp;
                            {years > 0 ? `${years} Year` : ""}
                            {months > 0
                              ? `${years > 0 ? " - " : ""}${months} Month`
                              : ""}
                          </>
                        )}
                      </option>
                    );
                  })
                ) : (
                  <option value="" style={{ color: "gray" }} disabled>
                    No interviewer present
                  </option>
                )}
              </select>
            </div>
            <div>
              <div>
                <label className="small mb-1" htmlFor="inputInterest">
                  Interview Mode
                </label>
                <select
                  style={{ height: "45px" }}
                  required
                  className="form-select"
                  name="interviewMode"
                  value={interviewMode}
                  onChange={handleInputChange}
                >
                  <option
                    disabled
                    value=""
                    selected
                    className="dropdown_option"
                  >
                    Select Interview Mode
                  </option>
                  <option className="dropdown_option" value="REMOTE">
                    Virtual
                  </option>
                </select>
              </div>
              <div>
                <label className="small mb-1" htmlFor="inputInterest">
                  Job Title
                </label>
                <input
                  className="form-control"
                  placeholder="Job Position"
                  name="jobPosition"
                  value={item?.jobTitle}
                  onChange={handleInputChange}
                  style={{ height: "45px" }}
                  readOnly
                />
              </div>
            </div>

            <div>
              <div className="label_job_schedule">
                <label className="small mb-1" htmlFor="inputInterest">
                  Interview Date
                </label>
                <DatePicker
                  placeholderText="Select interview date"
                  className="DateChange form-control w-100 mt-0 h-45 datePickerPlaceholderClass"
                  dateFormat="dd-MM-yyy"
                  selected={startDateForPicker}
                  onChange={selectDateHandler}
                  minDate={today}
                  todayButton={"Today"}
                />
              </div>
              <div className="label_job_schedule">
                <label className="small mb-1" htmlFor="inputInterest">
                  Interview Time
                </label>
                <select
                  name="interviewStartTime"
                  value={interviewStartTime}
                  onChange={handleTimeInputChange}
                  style={{
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    paddingLeft: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    width: "100%",
                  }}
                >
                  {Array.from({ length: 96 }).map((_, index) => {
                    const hour = Math.floor(index / 4);
                    const minute = (index % 4) * 15;
                    const time = `${String(hour).padStart(2, "0")}:${String(
                      minute
                    ).padStart(2, "0")}`;
                    return (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="label_job_schedule">
                <label className="small mb-1" htmlFor="inputInterest">
                  Interview Duration
                </label>
                <select
                  style={{ height: "45px" }}
                  required
                  className="form-select"
                  name="duration"
                  value={duration}
                  onChange={handleInputChange}
                >
                  <option
                    className="dropdown_option"
                    selected
                    disabled
                    value=""
                  >
                    Select Duration
                  </option>
                  <option className="dropdown_option" value="00:15:00">
                    15 min
                  </option>
                  <option className="dropdown_option" value="00:30:00">
                    30 min
                  </option>
                  <option className="dropdown_option" value="00:45:00">
                    45 min
                  </option>
                  <option className="dropdown_option" value="00:60:00">
                    60 min
                  </option>
                </select>
              </div>
            </div>

            <div className="label_job_schedule">
              <label className="small mb-1" htmlFor="timeZone">
                Interview Time zone
              </label>

              <TimezoneSelect
                id="timezone"
                value={selectedTimezone}
                onChange={setSelectedTimezone}
                labelStyle="altName"
              />
            </div>
          </Box>
          <p style={{ color: "red", marginLeft: "15px" }}>{error}</p>
          <DialogActions>
            <button
              className={`btn-primary-custom  ${isDisabled && "cursor_disabled"
              }`}
              disabled={isDisabled || loading}
              autoFocus
              type="submit"
            >
              {loading ? <>Loading....</> : <>Schedule</>}
            </button>
          </DialogActions>
        </form>
      </BootstrapDialog>
      <div onClick={handleClickOpen}>
        <FaRegCalendarCheck size={24} color="#286a94" className="pointer" />
      </div>
    </>
  );
};

export default NewScheduleInterview;
